import { gql } from '@apollo/client'

export type DemoApplicantType =
  | 'essentialTenant'
  | 'advancedTenant'
  | 'advancedGuarantor'
  | 'selfServeTenant'
  | 'selfServeGuarantor'
  | 'selfServeStudentTenant'

export type DemoIdvtType = 'NotRequired' | 'UKOnly' | 'Required'

export type DemoGuarantorProduct =
  | 'Essential'
  | 'Advanced'
  | 'Pro'
  | 'Hybrid'
  | 'Plus'
  | 'Priority'
  | 'Corporate'
  | 'DataCollection'
  | 'SelfServe'

export type MutationVars = {
  email: string
  customerId: string
  applicantType: DemoApplicantType
  identityProvider: IdentityProviderType
  idvt?: DemoIdvtType
  guarantorCollectionRequired?: boolean
  guarantorProduct?: DemoGuarantorProduct
}

export type DemoApplicant = {
  subjectId: string
  customerId: string
}

export type Response = {
  addDemoApplicant: DemoApplicant
}

type IdentityProviderType = 'entrust' | 'default'

const mutation = gql`
  mutation addDemoApplicant(
    $email: String!
    $customerId: String!
    $applicantType: DemoApplicantType!
    $identityProvider: IdentityProviderType!
    $idvt: DemoApplicantIdvt
    $guarantorCollectionRequired: Boolean
    $guarantorProduct: DemoGuarantorProduct
  ) {
    addDemoApplicant(
      email: $email
      customerId: $customerId
      applicantType: $applicantType
      identityProvider: $identityProvider
      idvt: $idvt
      guarantorCollectionRequired: $guarantorCollectionRequired
      guarantorProduct: $guarantorProduct
    ) {
      subjectId
      customerId
    }
  }
`

export default mutation
